import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/shadow.png';

const StyledWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;

const StyledContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 40px;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledSelectContainer = styled.div`
	position: relative;
	z-index: 3;
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledShadow = styled.div`
	position: absolute;
	left: 50%;
	bottom: -1200px;
	transform: translateX(-50%);
	z-index: -1;
	width: 1800px;
	height: 1800px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledCircleContainer = styled.div`
	position: relative;
	width: 200px;
	margin: 40px auto 0;
`;

const StyledFishIconContainer = styled.div`
	position: absolute;
	top: -6px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 30px;
	background-color: #2d70da;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledStartButton = styled.div`
	position: absolute;
	top: 118px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
	width: 80px;
	height: 80px;
	border-radius: 80px;
	background-color: #2d70da;
	cursor: pointer;
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #fff;

		img {
			filter: invert(1);
		}
	}

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}
`;

const StyledSelectItemContainer = styled.div`
	position: absolute;
	left: calc(50% - 240px);
`;

const StyledInventoryContainer = styled.div`
	position: absolute;
	left: calc(50% + 160px);
`;

const StyledUpText = styled(Text)`
	position: absolute;
	top: -41px;
	left: 50%;
	transform: translateX(-50%);
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 6px;
	font-size: 18px;
	text-align: center;
	color: #ffffff;
	white-space: nowrap;
	text-shadow:
		1px 0 0 rgba(0, 0, 0, 0.5),
		0 1px 0 rgba(0, 0, 0, 0.5),
		-1px 0 0 rgba(0, 0, 0, 0.5),
		0 -1px 0 rgba(0, 0, 0, 0.5);

	> div {
		color: initial;
		text-shadow: none;
		font-size: initial;
	}
`;

const StyledPanelControlsContainer = styled.div`
	position: absolute;
	bottom: 40px;
	right: 40px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 10px;
`;

export {
	StyledCircleContainer,
	StyledContainer,
	StyledFishIconContainer,
	StyledInventoryContainer,
	StyledPanelControlsContainer,
	StyledSelectContainer,
	StyledSelectItemContainer,
	StyledShadow,
	StyledStartButton,
	StyledUpText,
	StyledWrapper,
};
